import React, { useEffect, useState } from 'react'
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import CloseIcon from "@mui/icons-material/Close";
import useMediaQuery from "@mui/material/useMediaQuery"; 
import "../../../Component/Common/ReuseableComponent/ReuseableComponent.css";
import { PendingPoCard } from "./PendingPoCard";
import GCPendingPoCard from "./GCPendingPoCard";
import GCTitleSticky from "../../../Component/Common/ReuseableComponent/GCTitleSticky";
import moment from "moment";
import {
  Modal,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Checkbox,
  TextField,
  Button,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { DataGrid } from '@mui/x-data-grid'; 
import { WmsInboundReturnRo } from '../../../Redux/roStore';
import { PendingPODetail, saveGetPendingPoDetails } from '../../../Server/ApiV2';
import { fAlertToast } from '../../../Utility/Utilitys';

const GCLoadFromPo = ({
    xOpen=false,
    fCloseLoadPoModal=()=>{}, 
    xTitle="Load Po Detail",
    fNewDetail=() => {}
}) => {

    const [expanded, setExpanded] = useState(null); 

    const [maindata, setMaindata] = useState([]);
  
    const handleAccordionChange = (index) => {
      setExpanded(expanded === index ? null : index);

      setSelectedRows([])
    };

    const [selectedRows, setSelectedRows] = useState([]);

    const handleSelectionChange = (selectedIds, vocIndex) => {
       if (!maindata || maindata.length === 0) return;

      let updatedDetails = [...maindata];
      let updatedSelectedRows = [];
    
      updatedDetails[vocIndex].Details = updatedDetails[vocIndex].Details.map(row => {
        if (selectedIds.includes(row.B_Srno)) {
          // ✅ Assign B_Qty when checked
          updatedSelectedRows.push({
            B_VocTyp: row.B_VocTyp,
            B_VocNo: row.B_VocNo,
            B_Srno: row.B_Srno,
            B_ItmName: row.ItmName,
            B_Qty: row.B_Qty,
            FinalQty: row.FinalQty || row.B_Qty, 
          });
          return { ...row, FinalQty: row.FinalQty || row.B_Qty };
        } else {
          // ✅ Assign 0 when unchecked
          return { ...row, FinalQty: 0 };
        }
      });
    
      setMaindata(updatedDetails);
      setSelectedRows(updatedSelectedRows);
    };

    const fFinalQty = (params, vocIndex,value) => {
      
      if (Number(value) < 0) {
        
        fAlertToast("FAILED", "Final Qty should not be less than or equal to Qty");
        return params.row; 
      }
      
      const updatedDetails = maindata[vocIndex]?.Details.map((x) => {
        if (x.B_Srno === params.row.B_Srno) {
          return { ...x, FinalQty:value }; 
        }
        return x; 
      });
    
      
      setMaindata((prevMaindata) => {
        const updatedMaindata = [...prevMaindata];
        updatedMaindata[vocIndex] = {
          ...updatedMaindata[vocIndex],
          Details: updatedDetails, 
        };
        return updatedMaindata; 
      });
    
      params.row.FinalQty =value;
      let updatedSelectedRows = [...selectedRows];

      const rowExists = updatedSelectedRows.some((row) => row.B_Srno === params.row.B_Srno);
      if (!rowExists) {
        updatedSelectedRows.push({
          B_VocTyp: params.row.B_VocTyp,
          B_VocNo: params.row.B_VocNo,
          B_Srno: params.row.B_Srno,
          B_ItmName: params.row.ItmName,
          B_Qty: params.row.B_Qty,
          FinalQty: value,
        });
      } else {
        updatedSelectedRows = updatedSelectedRows.map((row) =>
          row.B_Srno === params.row.B_Srno ? { ...row, FinalQty: Number(value) } : row
        );
      }
    
      setSelectedRows(updatedSelectedRows); 
    
      return params.row;
    };


      console.log(maindata?.Details);
const fonload=async()=>{
  setExpanded(null);
  setSelectedRows([])
    setMaindata([])
   const { HeadObject } = WmsInboundReturnRo();
      let obj = {
        "Party": HeadObject.A_Party, 
        "Loc": HeadObject.A_Loc 
      }
      const resp = await PendingPODetail(obj);
      if(resp?.status === 200){
        console.log(resp?.data?.recordset);
        setMaindata(resp?.data?.recordset);
      }
}

const fonsave=async()=>{
//ATLEAST ONE LINE ITEM SHOULD BE SELECTED
// FinalQty SHOULD NOT  ZERO
//
if(selectedRows.length == 0){
  fAlertToast("INFO","LineItems should not be empty")
  return
}else{
 
  let obj=selectedRows.find(row => row.FinalQty == 0)
  if(!!obj){
    fAlertToast("INFO","FinalQty should not be zero")
    return
  }else{
    const {HeadObject} = WmsInboundReturnRo();
    const items = selectedRows?.map((item) => ({
        "B_VocTyp":item?.B_VocTyp,
        "B_VocNo": item?.B_VocNo,
        "B_Srno": item?.B_Srno,
        "B_ItmName":item?.B_ItmName,
        "B_Qty": item?.B_Qty,
        "FinalQty": item?.FinalQty
    }));
    let obj ={
        "VocTyp": HeadObject.A_VocTyp,
        "VocNo": HeadObject.A_VocNo,
        "LineItems": items
    }
  const resp = await saveGetPendingPoDetails(obj);
  if(resp?.status === 200){
    console.log('Response : ',resp);
    fAlertToast("SUCCESS","Transaction saved successfully")
    fNewDetail(
      HeadObject.A_VocNo,
      HeadObject.A_Rounding,
      HeadObject.A_VocTyp,
      HeadObject.TaxType
    );
    setSelectedRows([])
    setMaindata([])
    fCloseLoadPoModal()
  }
  }
}
  
}
 

useEffect(() => {
  if(xOpen){
    fonload();
  }

},[xOpen])

const [isEditing,setIsEditing] = useState(false);
 
  return (
    <Modal
    open={xOpen}
    onClose={() => {
      setMaindata([])
      fCloseLoadPoModal()
    }}
    aria-labelledby="modal-modal-title"
    aria-describedby="modal-modal-description"
  >
    <Box
      sx={{ flexGrow: 1, overflow: "auto" }}
      className="
      gnr-item-search 
      model-gc-search"
    >
       
      <GCTitleSticky title={xTitle} onClose={() => {
      setMaindata([])
      fCloseLoadPoModal()
    }} />
      
      <div className="p-2">

        <Box sx={{ padding: 3 }}>
          {maindata?.map((main, vocIndex) => (
            <Accordion key={vocIndex} expanded={expanded === vocIndex} onChange={() => handleAccordionChange(vocIndex)} sx={{ backgroundColor: "#f9f9f9", mb: 1 }}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography variant="subtitle1">{main.A_VocTyp} - {main.VocName} | {main.A_VocNo}</Typography>
            </AccordionSummary>
            <AccordionDetails>
                
              {/* <Box sx={{ backgroundColor: "inherit", color: "black", padding: "10px", borderRadius: 1, display: "flex", flexWrap: "wrap", gap: 2,boxShadow:2 }}>
                <Typography variant="body2"><strong>Voucher No:</strong> {main.A_VocTyp}</Typography>
                <Typography variant="body2"><strong>Post Date:</strong> {moment(main.A_PostDt).format('DD/MM/YYYY')}</Typography>
                <Typography variant="body2"><strong>Vendor Name:</strong> {main.PartyName}</Typography>
                <Typography variant="body2"><strong>Location:</strong> {main.LocName}</Typography>
                <Typography variant="body2"><strong>Buyer:</strong> {main.BuyerName}</Typography>
                <Typography variant="body2"><strong>Narration:</strong> {main.A_Narr}</Typography>
              </Box> */}

              <div style={{width:'100%',padding:2,display:'flex',justifyContent:'flex-end'}}>
                  <Button
                    sx={{width:'6%'}}
                    className='loadPoDGSaveButton'
                    variant="contained" 
                    size='small'
                    color="primary"    
                    disabled={isEditing}
                    onClick={() => {
                      fonsave(main,main?.Details,);
                    }}
                  >
                    Save
                  </Button>
                </div>

                    <div style={{ height: 325, width: '100%', marginTop: 1 }}>
                    <DataGrid
                      rows={main?.Details}
                      columns={[
                        { field: "B_VocTyp", headerName: "Doc No", width: 120, hide:true },
                        { field: "B_Srno", headerName: "Sr.No", width: 100 ,hide:true},
                        { field: "B_Itmcd", headerName: "Item Code", width: 120, },
                        { field: "ItmName", headerName: "Item Name", width: 300 },
                        { field: "B_Qty", headerName: "Qty", width: 90 },
                        { field: "B_Unit", headerName: "Unit", width: 80 },
                        {
                          field: "FinalQty",
                          headerName: "FinalQty",
                          width: 90,
                        
                          type: "number",
                          // valueSetter: (params) => fFinalQty(params, vocIndex),
                           renderCell: (params) => (
                              // <TextField
                              //   type="number"
                              //   value={params.value}
                              //   onChange={(e) =>{
                                  
                              //     fFinalQty(params, vocIndex,e.target.value)}
                              //   }
                              //   onBlur={() => setIsEditing(false)}
                              //   onFocus={() => setIsEditing(true)}
                              // />
                              <TextField
                              type="number"
                              value={params.value}
                              onChange={(e) => fFinalQty(params, vocIndex, e.target.value)}
                              onBlur={() => setIsEditing(false)}
                              onFocus={() => setIsEditing(true)}
                              onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                  e.preventDefault();
                                  const currentRowIndex = main.Details.findIndex(
                                    (row) => row.B_Srno === params.row.B_Srno
                                  );
                                  const nextRow = main.Details[currentRowIndex + 1];
                      
                                  if (nextRow) {
                                    const nextInput = document.querySelector(
                                      `input[name="FinalQty-${nextRow.B_Srno}"]`
                                    );
                                    if (nextInput) {
                                      nextInput.focus();
                                    }
                                  }
                                }
                              }}
                              inputProps={{ name: `FinalQty-${params.row.B_Srno}` }} // Unique input name for easy selection
                            />
                            ),
                        },
                      ]}
                      checkboxSelection
                      getRowId={(row) => row.B_Srno}
                      
                      rowHeight={30}
                      headerHeight={40}
                      onSelectionModelChange={(selectedIds) => handleSelectionChange(selectedIds, vocIndex)}
                      selectionModel={selectedRows.map(row => row.B_Srno)}
                      hideFooter={main?.Details.length < 100}
                      disableSelectionOnClick
                      onCellEditStart={() => setIsEditing(true)}
                      onCellEditStop={() => {setIsEditing(false)}}
                      onCellEditCommit={() => setIsEditing(false)}
                    />
                   </div>
                
                

            </AccordionDetails>
          </Accordion>
          ))}
        </Box>

       </div>

      </Box>
      </Modal> 

        

       

    
  )
}

export default GCLoadFromPo
